module.exports = __webpack_public_path__ + "stopcircle.svg?ad07c241f45555e9fccf8b8163b37885";